import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, ClockIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 27
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-24 px-4 bg-dark-DEFAULT relative overflow-hidden border-t border-dark-border" data-id="element-66">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-brand-DEFAULT/5 rounded-full blur-[100px] pointer-events-none" data-id="element-67"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-68">
        <h2 className="text-5xl md:text-6xl font-bebas mb-4" data-id="element-69">
          <span className="text-white" data-id="element-70">El próximo lunes puedes volver a </span>
          <span className="text-brand-DEFAULT" data-id="element-71">improvisar la sesión.</span>
        </h2>
        <p className="text-2xl md:text-3xl font-bebas text-text-secondary mb-8" data-id="element-72">
          O puedes entrar a la cancha con todo resuelto desde hoy.
        </p>

        <div className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full mb-12" data-id="element-73">
          <span data-id="element-74">⏰</span>
          <span className="text-sm text-text-secondary" data-id="element-75">
            El precio de lanzamiento cierra en{' '}
            <span className="font-bold text-brand-DEFAULT" data-id="element-76">
              {timeLeft.hours}hs {timeLeft.minutes}min {timeLeft.seconds}seg
            </span>
            . Después sube USD 5 y no vuelve.
          </span>
        </div>

        <div className="mb-12 text-left" data-id="element-77">
          <PricingSelector data-id="element-78" />
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-xs text-text-secondary" data-id="element-79">
          <span className="flex items-center" data-id="element-80">
            <LockIcon size={14} className="mr-1" data-id="element-81" /> Pago 100% seguro
          </span>
          <span className="flex items-center" data-id="element-82">
            <ClockIcon size={14} className="mr-1" data-id="element-83" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center" data-id="element-84">
            <ShieldCheckIcon size={14} className="mr-1" data-id="element-85" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-86">
            <CreditCardIcon size={14} className="mr-1" data-id="element-87" /> Tarjeta · PayPal ·
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}